import SEO from "@/components/SEO";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";
import PartituraManager from "./components/PartituraManager.tsx";
import CursoManager from "./components/CursoManager";
import ReleaseManager from "./components/ReleaseManager";

type Tab = "partituras" | "cursos" | "liberacao";

export default function AdminPartiturasPage() {
  const [tab, setTab] = useState<Tab>("partituras");

  const tabs: { key: Tab; label: string; icon: string }[] = [
    { key: "partituras", label: "Partituras", icon: "ri-file-music-line" },
    { key: "cursos", label: "Cursos", icon: "ri-graduation-cap-line" },
    { key: "liberacao", label: "Liberação", icon: "ri-key-2-line" },
  ];

  return (
    <>
      <SEO
        title="Painel Administrativo"
        description="Painel administrativo da GodoyProd para gerenciamento de partituras, cursos e liberação de acessos."
        keywords="admin, painel administrativo, gerenciar partituras, GodoyProd"
        noindex
        canonicalPath="/admin/partituras"
      />
      <div className="min-h-screen bg-godoy-black">
        <Navbar />

        <section className="pt-32 pb-20 md:pt-40 md:pb-28">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">
            <div className="mb-10">
              <span className="text-godoy-gold text-sm font-semibold tracking-widest uppercase">
                Painel Administrativo
              </span>
              <h1 className="font-serif text-3xl md:text-4xl font-bold text-godoy-cream mt-3">
                Gerenciar Partituras e Cursos
              </h1>
              <p className="text-godoy-lightgray mt-2 text-sm max-w-xl">
                Crie, edite e organize partituras e cursos, faça upload de PDFs e vídeos, libere acessos manualmente.
              </p>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-godoy-gray/20 pb-2">
              {tabs.map((t) => (
                <button
                  key={t.key}
                  onClick={() => setTab(t.key)}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                    tab === t.key
                      ? "bg-godoy-gold/10 text-godoy-gold border border-godoy-gold/30"
                      : "text-godoy-lightgray hover:text-godoy-cream hover:bg-godoy-charcoal/60"
                  }`}
                >
                  <i className={t.icon} />
                  {t.label}
                </button>
              ))}
            </div>

            {/* Content */}
            <div className="bg-godoy-charcoal/60 border border-godoy-gray/20 rounded-lg p-6 md:p-8">
              {tab === "partituras" && <PartituraManager />}
              {tab === "cursos" && <CursoManager />}
              {tab === "liberacao" && <ReleaseManager />}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}